import React, { Fragment, useEffect, useState } from "react"
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../../Components/Navbar/Navbar"
import trash from "./../../../Assets/Images/trash.png"
import Select from "react-select"
import { Select as SearchBox } from "antd"
import Upload from "antd/es/upload/Upload"
import { createSupplier } from "../../../Helpers/apiCalls/suppliersApi"
import InputError from "../../../Components/InputError/InputError"
import {
  antdesignSelectStyle,
  dateFormat,
  formatDate,
  formatDecimal,
  numberFormat,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi"
import {
  deleteBankAttachment,
  deleteCashAttachment,
  deleteCheckAttachment,
} from "../../../Helpers/apiCalls/Purchases/paySupplierApi"
import toast from "react-hot-toast"
import Moment from "moment"
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi"
import ReactLoading from "react-loading"
import upload from "../../../Assets/Images/upload.png"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import {
  createSalesInvoiceCashPayment,
  getSalesInvoiceCashSlip,
  updateSalesInvoiceCashPayment,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceCashPayment"
import { getSalesInvoice } from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceApi"
import {
  createSalesInvoiceCheckPayment,
  getSalesInvoiceCheckSlip,
  updateSalesInvoiceCheckPayment,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceCheckPayment"
import {
  createSalesInvoiceBankPayment,
  getSalesInvoiceBankSlip,
  updateSalesInvoiceBankPayment,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceBankPayment"
import {
  createSalesInvoiceOtherPayment,
  getSalesInvoiceOtherSlip,
  updateSalesInvoiceOtherPayment,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceOtherPayment"
import moment from "moment"
import Footer from "../../../Components/Footer/Footer"
import Modal from "antd/es/modal/Modal"
import FileExceedModal from "../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import noDataImg from "../../../Assets/Images/no-data-img.png"
import {
  validateSalesPaymentBank,
  validateSalesPaymentCash,
  validateSalesPaymentCheck,
  validateSalesPaymentOthers,
} from "../../../Helpers/Validation/Sales/SalesPaymentValidation"

/**
 *  COMPONENT: FORM TO ADD OR EDIT PAYMENT
 */
function SalesPaymentForm({ add, edit }) {
  const { Dragger } = Upload
  const [inactive, setInactive] = useState(true)
  const { id, type } = useParams()
  //
  let navigate = useNavigate()
  const [isClicked, setIsClicked] = useState(false)
  const [isChanged, setIsChanged] = useState(false)
  // PAYMENT DETAILS HANDLERS
  const [addDetails, setAddDetails] = useState({
    payment_date:
      type === "cash" || type === "bank" ? Moment().format("YYYY-MM-DD") : "",
    check_date: type === "check" ? Moment().format("YYYY-MM-DD") : "",
    issued_date: type === "check" ? Moment().format("YYYY-MM-DD") : "",
    payee: "",
    from_account_name: "",
    from_account_no: "",
    to_account_name: "",
    to_account_no: "",
    transaction_fee: 0,
    grand_total: 0,
    total_amount_due: 0,
    total_sales: 0,
    withholding_tax: 0,
    vat: 0,
    vat_sales: 0,
    wht_percentage: 0,
    acknowledged_by: "",
    commission: 0,
  })
  const [totalAmount, setTotalAmount] = useState(0)
  const [selectedEntry, setSelectedEntry] = useState("")
  const [entriesList, setEntriesList] = useState([])
  const [employees, setEmployees] = useState([])
  const [customers, setCustomers] = useState([])
  const [entries, setEntries] = useState([])
  const [items, setItems] = useState([])
  const [banks, setBanks] = useState([])
  const [fromBanks, setFromBanks] = useState([])
  const [toBanks, setToBanks] = useState([])
  const [file, setFile] = useState("")
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState([])
  const [numItemsAdded, setNumItemsAdded] = useState(0)

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    payment_date: false,
    customer_id: false,
    payee: false,
    acknowledged_by: false,
    list: false,
    listInfo: false,
  })

  // SELECT DROPSEARCH CHANGE HANDLER
  function handleSelectChange(e) {
    const newList = { ...addDetails }
    if (e.name === "customer_id") {
      setItems([])
      fetchSalesInvoices({
        customer_id: e.value,
        status: "open",
      })
      newList["customer_id"] = e.value
      newList["customer_id_value"] = { label: e.label, value: e.value }
    } else if (e.name === "bank_to") {
      newList["bank_to"] = e.label
      newList["to_account_no"] = e.account_no
      newList["to_account_name"] = e.account_name
    } else if (e.name === "acknowledged_by") {
      newList["acknowledged_by"] = e.value
      newList["acknowledged_by_value"] = { label: e.label, value: e.value }
    }
    setAddDetails(newList)
  }

  // PAYMENT DETAILS CHANGE HANDLER
  function handleAddDetailsChange(e) {
    const { name, value, checked } = e.target
    setIsChanged(true)
    if (name === "is_vat") {
      if (checked) {
        var vat_sales = parseFloat(addDetails.total_sales) / 1.12
        var vat = parseFloat(addDetails.total_sales) - vat_sales
        setAddDetails((prevState) => ({
          ...prevState,
          [name]: checked,
          vat_sales: vat_sales,
          vat: vat,
        }))
      } else {
        setAddDetails((prevState) => ({
          ...prevState,
          [name]: checked,
          vat_sales: 0,
          vat: 0,
        }))
      }
    } else if (name === "wht_percentage") {
      var percentage = value === "1" ? 0.01 : value === "2" ? 0.02 : 0
      if (addDetails.is_vat) {
        var wht = parseFloat(addDetails.vat_sales) * percentage
        setAddDetails((prevState) => ({
          ...prevState,
          [name]: checked,
          wht_percentage: percentage,
        }))
      } else {
        var wht = parseFloat(addDetails.total_sales) * percentage
        setAddDetails((prevState) => ({
          ...prevState,
          [name]: checked,
          wht_percentage: percentage,
        }))
      }
      // }
      // else if (name === "commision") {
      //   const commisionValue = parseFloat(value)
      //   const grandTotal =
      //     parseFloat(addDetails.subtotal) +
      //     parseFloat(addDetails.total_others) -
      //     commisionValue
      //   setAddDetails((prevState) => ({
      //     ...prevState,
      //     [name]: commisionValue,
      //     grand_total: grandTotal,
      //   }))
    } else {
      setAddDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
    setTimeout(() => setIsChanged(false), 10)
  }

  // ADD ANOTHER INVOICE HANDLER
  function AddItem() {
    const newItem = {
      entry: {
        name: "receive_id",
        label: "Select Invoice...",
        value: "",
      },
      amount: 0,
      // withholding: wthComputation(0),
      invoice_date: "",
    }
    setItems((prevItems) => [...prevItems, newItem])
    setNumItemsAdded((prevNum) => prevNum + 1)
  }

  // INVOICE REMOVAL HANDLER
  function handleRemoveItem(e, id) {
    setIsChanged(true)
    setSelectedEntry(id === 0 ? id : id - 1)
    const removedItem = items[id]
    const newItemList = [...items]
    newItemList.splice(id, 1)
    setItems(newItemList)
    setSelectedOptions((prevSelectedInvoices) =>
      prevSelectedInvoices.filter(
        (invoice) => invoice !== removedItem.entry.value
      )
    )
    if (selectedOptions.length === 0 && entries.length > 0) {
      const isAlreadyInOptions = entries.some(
        (entry) => entry.value === removedItem.entry.value
      )
      if (!isAlreadyInOptions) {
        setEntries((prevEntries) => [...prevEntries, removedItem.entry])
      }
      handleItemChange(e, "")
    }
  }

  function handleInvoiceChange(e, id, type) {
    setSelectedEntry(id)
    setIsChanged(true)

    setSelectedOptions((prevSelectedInvoices) => [...prevSelectedInvoices, e])

    const selectedValue = e
    if (selectedEntry === id) {
      // Get the previous selection for this row
      if (selectedOptions[id] !== undefined) {
        // Get the previous selection for this row
        const previousSelection = selectedOptions[id]

        // Remove the most recent selection from selectedOptions
        setSelectedOptions((prevSelectedOptions) =>
          prevSelectedOptions.filter((option) => option !== previousSelection)
        )

        const isDuplicate = entries.some(
          (entry) => entry.value === previousSelection
        )

        // Put the previous selection back to the options list if it's not a duplicate
        if (!isDuplicate) {
          setEntries((prevEntries) => [...prevEntries, previousSelection])
        }
      }
    }

    const entryData = entries.filter((entry) => entry.value === selectedValue)
    const newItems = items.map((item, index) => {
      if (index === id) {
        const newItem = { ...item } // Copy the item object

        // Update item properties based on the selected entryData
        newItem.entry = {
          name: "entry",
          label: entryData[0]?.label,
          value: entryData[0]?.value,
        }

        // Update other item properties as needed based on entryData
        newItem.sales_invoice_id = entryData[0]?.id
        newItem.invoice_date = entryData[0]?.invoice_date
        newItem.amount = entryData[0]?.amount
        newItem.other_fees = entryData[0]?.other_fees
        newItem.withholding = entryData[0]?.withholding
        newItem.withholding_percentage = entryData[0]?.withholding_percentage
        newItem.vat_type = entryData[0]?.vat_type
        newItem.subtotal =
          parseFloat(entryData[0]?.amount) -
          parseFloat(entryData[0]?.withholding)
        newItem.grand_amount =
          parseFloat(entryData[0]?.amount) +
          parseFloat(entryData[0]?.other_fees) -
          parseFloat(entryData[0]?.withholding)

        return newItem
      }
      return item
    })

    // Update items state
    setItems(newItems)
    setTimeout(() => setIsChanged(false), 10)
  }

  const filteredOptions = entries.filter(
    (entry) => !selectedOptions.includes(entry.value)
  )

  // INVOICE CHANGE HANDLER
  function handleItemChange(e, id) {
    setSelectedEntry(id)
    setIsChanged(true)
    const { name, label, value } = e

    if (name === "invoice_no") {
      if (selectedEntry === id) {
        var entryData = entries.filter((entry) => {
          return entry.value === value
        })
        setEntries(entriesList.filter((data) => data.value !== value))
      } else {
        var entryData = entries.filter((entry) => {
          return entry.value === value
        })
        setEntries(entries.filter((data) => data.value !== value))
      }

      // setEntries(entryData)

      var newItemList = items
      var newEntries = newItemList.map((item, index) => {
        if (index === id) {
          var info = {
            name: name,
            label: label,
            value: value,
          }
          item.entry = info
          item.sales_invoice_id = e.id
          item.invoice_date = e.invoice_date
          item.amount = entryData[0]?.amount
          item.other_fees = entryData[0]?.other_fees
          item.withholding = entryData[0]?.withholding
          item.withholding_percentage = entryData[0]?.withholding_percentage
          item.vat_type = entryData[0]?.vat_type
          item.subtotal =
            parseFloat(entryData[0]?.amount) -
            parseFloat(entryData[0]?.withholding)
          item.grand_amount =
            parseFloat(entryData[0]?.amount) +
            parseFloat(entryData[0]?.other_fees) -
            parseFloat(entryData[0]?.withholding)
        }
        return item
      })
      setItems(newEntries)
    } else {
      const { name, value } = e.target
      const list = [...items]

      if (name === "amount") {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
            const wth_percentage = parseFloat(item.withholding_percentage) / 100
            if (item.vat_type === "VAT") {
              const vatableSales = parseFloat(item.amount) / 1.12
              item["withholding"] = parseFloat(
                vatableSales * wth_percentage
              ).toFixed(2)
            } else {
              item["withholding"] = 0
            }
            item["subtotal"] =
              parseFloat(item.amount) - parseFloat(item.withholding)
            item["grand_amount"] =
              parseFloat(item.amount) +
              parseFloat(item.other_fees) -
              parseFloat(item.withholding)
          }
        })
      } else if (name === "other_fees") {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
            item["subtotal"] =
              parseFloat(item.amount) - parseFloat(item.withholding)
            item["grand_amount"] =
              parseFloat(item.amount) +
              parseFloat(value) -
              parseFloat(item.withholding)
          }
        })
      } else {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
          }
        })
      }
      setItems(list)
    }
    setTimeout(() => setIsChanged(false), 10)
  }

  //  DISPLAY THE LIST OF ITEMS TABLE
  function renderTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Entry</th>
            <th>Invoice Date</th>
            <th>Invoice Details</th>
            <th>Amount (PHP)</th>
            <th>Service Fee</th>
            <th>Withholding</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index}>
                <td className="select-cell">
                  {/* <Select
                    // className="text-start react-select-container"
                    classNamePrefix="react-select"
                    className="react-select-container w-full"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    placeholder="Select Invoice..."
                    options={entries}
                    value={item.entry}
                    onChange={(e) => handleItemChange(e, index)}
                  /> */}
                  <SearchBox
                    // showSearch
                    value={item.entry.label}
                    placeholder={"Search Item..."}
                    className="react-select-container w-full"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    options={(filteredOptions || []).map((d) => ({
                      value: d.value,
                      label: d.label,
                    }))}
                    onChange={(e) =>
                      handleInvoiceChange(e, index, "invoice_id")
                    }
                  />
                </td>
                <td>
                  {item.invoice_date ? dateFormat(item.invoice_date) : ""}
                </td>
                <td>
                  <button
                    type="button"
                    className="button-primary view-btn me-3"
                    onClick={() => handleViewPayment(item.entry.value, type)}
                  >
                    View
                  </button>
                </td>
                <td className="d-flex align-contents select-cell">
                  <Col>
                    <Form.Control
                      type="number"
                      name="amount"
                      className="hide-spinner w-full"
                      value={item.amount}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                    <InputError
                      isValid={isError.listInfo}
                      message={"Amount is required"}
                    />
                  </Col>
                </td>
                <td className="select-cell">
                  <Col>
                    <Form.Control
                      type="number"
                      name="other_fees"
                      className="hide-spinner w-full"
                      value={item.other_fees}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </Col>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="withholding"
                    className="hide-spinner"
                    value={item.withholding}
                    onChange={(e) => handleItemChange(e, index)}
                    disabled
                  />
                </td>
                <td>
                  <img
                    src={trash}
                    alt="delete"
                    onClick={(e) =>
                      handleRemoveItem(
                        {
                          target: {
                            value: item.entry.value,
                            name: "id",
                          },
                        },
                        index
                      )
                    }
                    className="cursor-pointer"
                  />
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function handleViewPayment(id, type) {
    window.open("/wholesaleinvoice/print/" + id, "_blank")
  }

  async function deleteAttachment(selectedFile) {
    if (type === "bank") {
      const response = await deleteBankAttachment({
        bank_slip_id: id,
        attachment_id: selectedFile.id,
      })
    } else if (type === "cash") {
      const response = await deleteCashAttachment({
        cash_slip_id: id,
        attachment_id: selectedFile.id,
      })
    } else if (type === "check") {
      const response = await deleteCheckAttachment({
        check_slip_id: id,
        attachment_id: selectedFile.id,
      })
    }
  }

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    setPrevAttachments(newList)
    setPreview(false)
  }

  async function fetchCustomers() {
    setCustomers([])

    const response = await getCustomer({})
    if (response.data) {
      var customers = response.data.data.map((customer) => {
        var info = customer
        info.name = "customer_id"
        info.select_variable = "customer_id_value"
        info.label = customer.trade_name
        info.value = customer.id
        info.payee = customer.payee
        return info
      })
      setCustomers(customers)
    }
  }

  async function fetchBanks() {
    const response = await getAllBanks()
    if (response.data) {
      if (response.data) {
        var data = response.data.data
        // //
        var allBanks = data.map((bank) => {
          var info = {}
          info.name = "bank_id"
          info.select_variable = "bank_id_value"
          info.label = bank.bank_name
          info.value = bank.id
          info.bank_id = bank.id
          return info
        })
        setBanks(allBanks)

        var fromBanks = data.map((bank) => {
          var info = {}
          info.name = "bank_from"
          info.select_variable = "bank_from_value"
          info.label = bank.bank_name
          info.value = bank.id
          info.bank_id = bank.bank_id
          return info
        })
        setFromBanks(fromBanks)

        var toBanks = data.map((bank) => {
          var info = {}
          info.name = "bank_to"
          info.select_variable = "bank_to_value"
          info.label = bank.bank_name
          info.value = bank.id
          info.bank_id = bank.bank_id
          info.account_name = bank.account_name
          info.account_no = bank.account_no
          return info
        })
        setToBanks(toBanks)
      }
    } else {
      TokenExpiry(response)
    }
  }

  // ! ENTRY LABELS STILL EMPTY STRING
  async function fetchSalesPayment(id) {
    var response = {}
    if (type === "cash") {
      response = await getSalesInvoiceCashSlip(id)
    } else if (type === "check") {
      response = await getSalesInvoiceCheckSlip(id)
    } else if (type === "bank") {
      response = await getSalesInvoiceBankSlip(id)
    } else if (type === "other" || type === "others") {
      response = await getSalesInvoiceOtherSlip(id)
    }
    if (response.data) {
      var data = response.data.data[0]
      data.customer_id_value = {
        label: data.customer_name,
        value: data.customer_id,
      }
      // data.payee = {
      //   label: data.payee,
      // }
      data.acknowledged_by_value = {
        label: data.acknowledged_by,
        value: data.acknowledged_by,
      }
      data.bank_from_value = {
        label: data.bank_from_name,
        value: data.bank_from,
      }
      data.bank_id_value = {
        label: data.bank_name,
        value: data.bank_id,
      }

      setAddDetails(data)
      setTotalAmount(data.amount)

      if (type === "cash") {
        setPrevAttachments(data.sales_invoice_cash_slip_attachments)
        var cashEntries = data.sales_invoice_cash_entries.map((entry) => {
          var info = entry
          info.entry = {
            name: "sales_invoice_id",
            label: entry.invoice_label,
            value: parseInt(entry.sales_invoice_id),
          }
          info.amount = entry.amount
          info.invoice_date = moment(entry.added_on).format("MM-DD-YYYY")
          info.withholding = parseFloat(entry.withholding_tax)
          info.other_fees = parseFloat(entry.service_fee_payment)
          info.subtotal =
            parseFloat(entry.amount) - parseFloat(entry.withholding_tax)
          info.grand_amount =
            parseFloat(entry.amount) +
            parseFloat(entry.service_fee_payment) -
            parseFloat(entry.withholding_tax)

          return info
        })
        setItems(cashEntries)
      } else if (type === "check") {
        setPrevAttachments(data.sales_invoice_check_slip_attachments)
        var checkEntries = data.sales_invoice_check_entries.map((entry) => {
          var info = entry
          info.entry = {
            name: "sales_invoice_id",
            label: entry.invoice_label,
            value: parseInt(entry.sales_invoice_id),
          }
          info.amount = entry.amount
          info.invoice_date = moment(entry.added_on).format("MM-DD-YYYY")
          info.withholding = parseFloat(entry.withholding_tax)
          info.other_fees = parseFloat(entry.service_fee_payment)
          info.subtotal =
            parseFloat(entry.amount) - parseFloat(entry.withholding_tax)
          info.grand_amount =
            parseFloat(entry.amount) +
            parseFloat(entry.service_fee_payment) -
            parseFloat(entry.withholding_tax)

          return info
        })
        setItems(checkEntries)
      } else if (type === "bank") {
        setPrevAttachments(data.sales_invoice_bank_slip_attachments)
        var bankEntries = data.sales_invoice_bank_entries.map((entry) => {
          var info = entry
          info.entry = {
            name: "sales_invoice_id",
            label: entry.invoice_label,
            value: parseInt(entry.sales_invoice_id),
          }
          info.amount = entry.amount
          info.invoice_date = moment(entry.added_on).format("MM-DD-YYYY")
          info.withholding = parseFloat(entry.withholding_tax)
          info.other_fees = parseFloat(entry.service_fee_payment)
          info.subtotal =
            parseFloat(entry.amount) - parseFloat(entry.withholding_tax)
          info.grand_amount =
            parseFloat(entry.amount) +
            parseFloat(entry.service_fee_payment) -
            parseFloat(entry.withholding_tax)

          return info
        })
        setItems(bankEntries)
      } else if (type === "other" || type === "others") {
        setPrevAttachments(data.sales_invoice_other_slip_attachments)
        var otherEntries = data.sales_invoice_other_entries.map((entry) => {
          var info = entry
          info.entry = {
            name: "sales_invoice_id",
            label: entry.invoice_label,
            value: parseInt(entry.sales_invoice_id),
          }
          info.amount = entry.amount
          info.invoice_date = moment(entry.added_on).format("MM-DD-YYYY")
          info.withholding = parseFloat(entry.withholding_tax)
          info.other_fees = parseFloat(entry.service_fee_payment)
          info.subtotal =
            parseFloat(entry.amount) - parseFloat(entry.withholding_tax)
          info.grand_amount =
            parseFloat(entry.amount) +
            parseFloat(entry.service_fee_payment) -
            parseFloat(entry.withholding_tax)

          return info
        })
        setItems(otherEntries)
      }
    } else {
      TokenExpiry(response)
    }
  }

  // TO FETCH INVOICE (CHANGE WHEN API IS READY)
  async function fetchSalesInvoices(data) {
    console.log(data)
    const response = await getSalesInvoice(data)
    if (response.data) {
      console.log(response.data)
      var clean = response.data.data.map((entry) => {
        var info = entry
        var labelKeyword =
          entry.invoice_no !== "" &&
          entry.invoice_no !== null &&
          entry.invoice_no !== "null"
            ? "Invoice No. " + entry.invoice_no
            : entry.dr_no !== "" && entry.dr_no !== null
            ? "DR No. " + entry.dr_no
            : "Invoice " + entry.id
        info.name = "invoice_no"
        info.value = entry.id
        info.label = labelKeyword + " - " + entry.grand_total
        info.entry = {
          name: "invoice_no",
          value: entry.id,
          label: labelKeyword + " - " + entry.grand_total,
        }
        info.invoice_date = entry.sales_date ? entry.sales_date : ""

        info.amount = parseFloat(entry.discounted_subtotal_balance)
        info.other_fees = parseFloat(entry.service_fee_balance)
        // info.withholding = entry.withholding_tax
        info.withholding_percentage = entry.withholding_percentage
          ? entry.withholding_percentage
          : 0
        info.vat_type = entry.vat_type

        // WITHHOLDING CAlCULATION
        const percentage = entry.withholding_percentage
          ? entry.withholding_percentage
          : 0
        const wth_percentage = parseFloat(percentage) / 100
        if (entry.vat_type === "VAT") {
          const vatableSales =
            parseFloat(entry.discounted_subtotal_balance) / 1.12
          info.withholding = parseFloat(vatableSales * wth_percentage).toFixed(
            2
          )
        } else {
          info.withholding = 0
        }
        info.subtotal =
          parseFloat(entry.discounted_subtotal_balance) +
          parseFloat(entry.service_fee_balance) -
          parseFloat(info.withholding)

        return info
      })
      //
      setEntries(clean)
      setSelectedOptions(clean)
      setEntriesList(clean)
    } else {
      TokenExpiry(response)
      setEntries([])
    }
  }

  /** POST API - SAVE NEW PAYMENT **/
  async function handleSavePayment() {
    addDetails.attachments = fileList
    addDetails.amount = totalAmount
    setIsClicked(true)
    // if (validatePaymentListCash(addDetails, items, setIsError)) {
    var response = {}
    if (type === "cash") {
      if (validateSalesPaymentCash(addDetails, items, setIsError)) {
        response = await createSalesInvoiceCashPayment(addDetails, items)
      } else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "check") {
      if (validateSalesPaymentCheck(addDetails, items, setIsError))
        response = await createSalesInvoiceCheckPayment(addDetails, items)
      else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "bank") {
      if (validateSalesPaymentBank(addDetails, items, setIsError))
        response = await createSalesInvoiceBankPayment(addDetails, items)
      else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "others") {
      if (validateSalesPaymentOthers(addDetails, items, setIsError))
        response = await createSalesInvoiceOtherPayment(addDetails, items)
      else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    }
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      setTimeout(() => {
        navigate("/salespayment")
      }, 1000)
    } else {
      toast.error("Something went wrong", {
        style: toastStyle(),
      })
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setTimeout(() => {
      setIsClicked(false)
    }, 1000)
  }

  /** POST API - EDIT EXISTING PAYMENT **/
  async function handleUpdatePayment() {
    addDetails.attachments = fileList
    // if (validatePaymentListCash(addDetails, items, setIsError)) {
    setIsClicked(true)
    var response = {}
    if (type === "cash") {
      response = await updateSalesInvoiceCashPayment(addDetails, items)
    } else if (type === "check") {
      response = await updateSalesInvoiceCheckPayment(addDetails, items)
    } else if (type === "bank") {
      response = await updateSalesInvoiceBankPayment(addDetails, items)
    } else if (type === "other" || type === "others") {
      response = await updateSalesInvoiceOtherPayment(addDetails, items)
    }
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      setTimeout(() => {
        navigate("/salespayment")
      }, 1000)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
      // toast.error("Something went wrong", {
      //     style: toastStyle(),
      // })
    }
    setIsClicked(false)
    // } else {
    //     toast.error("Please fill in all required fields", {
    //         style: toastStyle(),
    //     });
    // }
  }

  // function handleCommisionChange(commission) {
  //   setCommision(commision)
  //    setAddDetails([...addDetails, { commission: commission }])
  // }

  async function fetchEmployees() {
    setEmployees([])
    const response = await getAllEmployees()

    if (response.data) {
      //
      let result = response.data.data.map((a) => {
        var fullName = `${a.first_name} ${a.last_name}`
        return {
          name: "acknowledged_by",
          select_variable: "acknowledged_by_value",
          label: fullName,
          value: fullName,
        }
      })
      //
      setEmployees(result)
    } else {
      TokenExpiry(response)
    }
  }

  function handleSubmit() {
    if (add) handleSavePayment()
    if (edit) handleUpdatePayment()
  }

  useEffect(() => {
    if (edit) {
      fetchSalesPayment(id)
    }
    fetchCustomers()
    fetchBanks()
    fetchEmployees()
  }, [])

  useEffect(() => {
    setNumItemsAdded(items.length)
  }, [items])

  // TOTAL AMOUNT, GRAND TOTAL AND WITHHOLDING TAX CALCULATION
  useEffect(() => {
    var _total = 0
    var _subtotal = 0
    var _item_withholding = 0
    var _item_other_fees = 0
    for (var i = 0; i < items.length; i++) {
      _subtotal +=
        parseFloat(items[i].amount) - parseFloat(items[i].withholding) // subtotal = amount - withholding per item
      _item_withholding += parseFloat(items[i].withholding) // withholding total
      _item_other_fees += parseFloat(items[i].other_fees) // other total
      _total += parseFloat(items[i].amount) // amount total
    }

    var _grand_total =
      _total - _item_withholding + _item_other_fees - addDetails.commission

    setAddDetails((prevState) => ({
      ...prevState,
      total_amount: _total,
      subtotal: _subtotal,
      grand_total: _grand_total,
      withholding_tax_total: _item_withholding,
      total_others: _item_other_fees,
    }))
  }, [isChanged])

  // useEffect(() => {
  //     var _total = items
  //         .map((item) => parseFloat(item.amount))
  //         .reduce((a, b) => a + b, 0);

  //     var _wht = 0
  //     if(addDetails.is_vat) {
  //         _wht = parseFloat(addDetails.vat_sales) * addDetails.wht_percentage
  //     } else {
  //         _wht = parseFloat(addDetails.total_sales) * addDetails.wht_percentage
  //     }

  //     var _trans_fee = addDetails.transaction_fee !== "" ? parseFloat(addDetails.transaction_fee) : 0
  //     var _grand_total = (parseFloat(addDetails.total_sales) - _wht) - _trans_fee;

  //     setAddDetails((prevState) => ({
  //         ...prevState,
  //         total_sales: _total,
  //         grand_total: _grand_total,
  //         withholding_tax: _wht
  //     }));

  // }, [isChanged]);

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SALES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-1 ms-1 ms-md-0 ps-md-0 ms-md-0 fs-2">
              SALES PAYMENT ({type})
            </h1>
          </Col>
        </Row>

        {/* FORM */}

        <div className="edit-form ps-form">
          {type === "check" && (
            <Fragment>
              <Row className="mb-3">
                <Col>
                  <span className="nc-modal-custom-row uppercase">
                    Bank
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="bank_name"
                    className="ps-label-content"
                    value={addDetails.bank_name}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  {/* <Select
                                        className="react-select-container nc-modal-custom-row-grey"
                                        classNamePrefix="react-select"
                                        placeholder="Select Bank..."
                                        value={addDetails.bank_id_value}
                                        options={banks}
                                        onChange={(e) => handleSelectChange(e)}
                                    /> */}
                  <InputError
                    isValid={isError.bank_name}
                    message={"Bank is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={4}>
                  <span className="nc-modal-custom-row uppercase">
                    Check Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="check_date"
                    defaultValue={addDetails.check_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Check No.
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="check_no"
                    defaultValue={addDetails.check_no}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.check_no}
                    message={"Check no is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Issue Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="issued_date"
                    defaultValue={addDetails.issued_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Customer Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Customer..."
                    value={addDetails.customer_id_value}
                    options={customers}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.customer_id}
                    message={"Customer is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Payee
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="payee"
                    defaultValue={addDetails.payee}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.payee}
                    message={"Payee is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Acknowledged By
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select employee..."
                    value={addDetails.acknowledged_by_value}
                    options={employees}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.acknowledged_by}
                    message={"Acknowledged by is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                  <Form.Control
                    type="text"
                    name="particulars"
                    className="nc-modal-custom-row-grey"
                    defaultValue={addDetails.particulars}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
          {type === "cash" && (
            <Fragment>
              <Row className="mb-3">
                <Col xs={12} lg={8}>
                  <span className="nc-modal-custom-row uppercase">
                    Customer Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Customer..."
                    value={addDetails.customer_id_value}
                    options={customers}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.customer_id}
                    message={"customer is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Payment Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="payment_date"
                    defaultValue={addDetails.payment_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.payment_date}
                    message={"Payment Date is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Payee
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="payee"
                    defaultValue={addDetails.payee}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.payee}
                    message={"Payee is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Acknowledged by
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select employee..."
                    value={addDetails.acknowledged_by_value}
                    options={employees}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.acknowledged_by}
                    message={"Acknowledged By is required"}
                  />
                </Col>
              </Row>
              <Row>
                <span className="nc-modal-custom-row uppercase">
                  Remarks
                  <span className="edit-optional px-2">(Optional)</span>
                </span>
                <Col>
                  <Form.Control
                    as="textarea"
                    name="particulars"
                    defaultValue={addDetails.particulars}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
          {type === "bank" && (
            <Fragment>
              <Row className="mb-3">
                <Col xs={12} lg={4}>
                  <span className="nc-modal-custom-row uppercase">
                    From Bank
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="bank_from"
                    className="ps-label-content"
                    defaultValue={addDetails.bank_from}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  {/* <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        value={addDetails.bank_from_value}
                                        placeholder="Select Bank..."
                                        options={fromBanks}
                                        onChange={(e) => handleSelectChange(e)}
                                    /> */}
                  <InputError
                    isValid={isError.bank_from}
                    message={"Bank from is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Payment Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="payment_date"
                    defaultValue={addDetails.payment_date}
                    className="nc-modal-custom-row-grey "
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.payment_date}
                    message={"Payment date is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Reference No.
                    {/* <label className="badge-required">{` *`}</label> */}
                  </span>
                  <Form.Control
                    type="text"
                    name="reference_no"
                    className="ps-label-content"
                    defaultValue={addDetails.reference_no}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.reference_no}
                    message={"Reference no is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Account Number
                    {/* <label className="badge-required">{` *`}</label> */}
                  </span>
                  <Form.Control
                    type="text"
                    name="from_account_no"
                    className="ps-label-content"
                    defaultValue={addDetails.from_account_no}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.from_account_no}
                    message={"Account no is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Account Name
                    {/* <label className="badge-required">{` *`}</label> */}
                  </span>
                  <Form.Control
                    type="text"
                    name="from_account_name"
                    className="ps-label-content"
                    defaultValue={addDetails.from_account_name}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.from_account_name}
                    message={"Account name is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Customer Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier..."
                    value={addDetails.customer_id_value}
                    options={customers}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.customer_id}
                    message={"Customer is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Payee
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="payee"
                    className="ps-label-content"
                    defaultValue={addDetails.payee}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.payee}
                    message={"Payee is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={4}>
                  <span className="nc-modal-custom-row uppercase">
                    To Bank
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    value={addDetails.bank_to_value}
                    placeholder="Select Bank..."
                    options={toBanks}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  {/* <Form.Control
                                        type="text"
                                        name="bank_to"
                                        className="ps-label-content"
                                        defaultValue={addDetails.bank_to}
                                        onChange={(e) => handleAddDetailsChange(e)}
                                    /> */}
                  <InputError
                    isValid={isError.bank_to}
                    message={"Bank to is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Account Number
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="to_account_no"
                    className="ps-label-content"
                    value={addDetails.to_account_no}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.to_account_no}
                    message={"Account no is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Account Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="to_account_name"
                    className="ps-label-content"
                    value={addDetails.to_account_name}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.to_account_name}
                    message={"Account name is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Acknowledged By
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select employee..."
                    value={addDetails.acknowledged_by_value}
                    options={employees}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.acknowledged_by}
                    message={"Acknowledged by is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                  <Form.Control
                    type="text"
                    name="particulars"
                    className="ps-label-content"
                    defaultValue={addDetails.particulars}
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
          {(type === "others" || type === "other") && (
            <Fragment>
              <Row className="mb-3">
                <Col xs={12} lg={8}>
                  <span className="nc-modal-custom-row uppercase">
                    Customer Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier..."
                    value={addDetails.customer_id_value}
                    options={customers}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.customer_id}
                    message={"Customer is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Payment Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="payment_date"
                    defaultValue={addDetails.payment_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.payment_date}
                    message={"Payment Date is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Type
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="transaction_type"
                    defaultValue={addDetails.transaction_type}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.transaction_type}
                    message={"Type is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Reference No.
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="transaction_no"
                    defaultValue={addDetails.transaction_no}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.transaction_no}
                    message={"Reference No. is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Payee
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="payee"
                    defaultValue={addDetails.payee}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                  <InputError
                    isValid={isError.payee}
                    message={"Payee is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Acknowledged by
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select employee..."
                    value={addDetails.acknowledged_by_value}
                    options={employees}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.acknowledged_by}
                    message={"Acknowledged By is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <span className="nc-modal-custom-row uppercase">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                  <Form.Control
                    as="textarea"
                    name="particulars"
                    defaultValue={addDetails.particulars}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handleAddDetailsChange(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          )}

          {/* INVOICES */}
          <div className="mt-3 d-flex flex-column">
            <span className="nc-modal-custom-row mb-2 uppercase">
              Applied to following invoices
            </span>
            <Container fluid className="edit-purchased-items">
              {items.length === 0 ? (
                <div className="entries-not-found">
                  {add && "You haven't added any invoices yet."}
                  {edit && "Entries not found."}
                </div>
              ) : (
                <>{renderTable()}</>
              )}
            </Container>
            <Row className="pt-3 PO-add-item">
              <InputError
                isValid={isError.list}
                message={"Please add at least one invoice!"}
              />
            </Row>
            <Row className="my-2 align-right pb-2 align-items-start">
              <Col className="pt-3 PO-add-item">
                <Button type="button" onClick={() => AddItem()}>
                  Add Invoice
                </Button>
              </Col>
              {items.length !== 0 && (
                <>
                  <Col className="pt-3">
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        TOTAL AMOUNT
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(addDetails.total_amount)}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        TOTAL WHT
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(addDetails.withholding_tax_total)}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        SUBTOTAL
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(addDetails.subtotal)}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        TOTAL OTHERS
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(addDetails.total_others)}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        COMMISSION
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        <Form.Control
                          type="text"
                          name="commission"
                          className="ps-label-content text-end px-1"
                          placeholder="0"
                          // value={
                          //   addDetails.commission
                          //     ? formatDecimal(addDetails.commission)
                          //     : 0
                          // }
                          value={addDetails.commission}
                          onChange={(e) => handleAddDetailsChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col
                        xs={4}
                        className="bold text-end print-table-footer-label"
                      >
                        GRAND TOTAL
                      </Col>
                      <Col
                        xs={4}
                        className="bold text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(addDetails.grand_total)}
                      </Col>
                    </Row>
                  </Col>
                </>
              )}
              {/* {items.length !== 0 && (
                                <>
                                    <Col className="pt-3">
                                        <Row className="mb-3">
                                            <Col
                                                xs={4}
                                                className="print-table-footer-label"
                                            >
                                                Total Sales
                                            </Col>
                                            <Col className="print-table-footer-data ps-4">
                                                {"PHP " + numberFormat(addDetails.total_sales)}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col
                                                xs={4}
                                                className="print-table-footer-label"
                                            >
                                                Vatable Sales
                                            </Col>
                                            <Col className="print-table-footer-data ps-4">
                                                { "PHP " + numberFormat(addDetails.vat_sales)}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col
                                                xs={4}
                                                className="print-table-footer-label"
                                            >
                                                <Form.Group
                                                    className=""
                                                    controlId="formBasicCheckbox"
                                                >
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="VAT"
                                                        name="is_vat"
                                                        className="pt-2"
                                                        onChange={(e) => handleAddDetailsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className="print-table-footer-data ps-4">
                                                { "PHP " + numberFormat(addDetails.vat)}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col xs={1} className="print-table-footer-label">
                                                WHT
                                            </Col>
                                            <Col xs={1} className="print-table-footer-label">
                                                <Form.Group
                                                    className=""
                                                    controlId="formBasicCheckbox"
                                                >
                                                    <Form.Check
                                                        type="radio"
                                                        label="1%"
                                                        name="wht_percentage"
                                                        value="1"
                                                        className="pt-2"
                                                        onChange={(e) => handleAddDetailsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={1} className="print-table-footer-label">
                                                <Form.Group
                                                    className=""
                                                    controlId="formBasicCheckbox"
                                                >
                                                    <Form.Check
                                                        type="radio"
                                                        label="2%"
                                                        name="wht_percentage"
                                                        value="2"
                                                        className="pt-2"
                                                        onChange={(e) => handleAddDetailsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={1} className="print-table-footer-label">
                                                <Form.Group
                                                    className=""
                                                    controlId="formBasicCheckbox"
                                                >
                                                    <Form.Check
                                                        type="radio"
                                                        label="N/A"
                                                        name="wht_percentage"
                                                        value="0"
                                                        className="pt-2"
                                                        onChange={(e) => handleAddDetailsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className="print-table-footer-data ps-4">
                                                { "PHP " + numberFormat(addDetails.withholding_tax)}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col
                                                xs={4}
                                                className="print-table-footer-label"
                                            >
                                                Total Amount Due
                                            </Col>
                                            <Col className="print-table-footer-data ps-4">
                                                { "PHP " + numberFormat(addDetails.grand_total)}
                                            </Col>
                                        </Row>
                                        {type === "bank" && (
                                            <>
                                                <Row className="mb-3">
                                                    <Col
                                                        xs={4}
                                                        className="print-table-footer-label"
                                                    >
                                                        TRANSACTION FEE
                                                    </Col>
                                                    <Col
                                                        xs={4}
                                                        className="print-table-footer-data ps-4"
                                                    >
                                                        <Form.Control
                                                            type="number"
                                                            name="transaction_fee"
                                                            className="hide-spinner numeric-input"
                                                            value={addDetails.transaction_fee}
                                                            onChange={(e) => handleAddDetailsChange(e)}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col
                                                        xs={4}
                                                        className="print-table-footer-label"
                                                    >
                                                        GRAND TOTAL
                                                    </Col>
                                                    <Col className="print-table-footer-data ps-4">
                                                        {"PHP " + numberFormat(addDetails.grand_total)}
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    </Col>
                                </>
                            )} */}
            </Row>
          </div>

          {edit && (
            <>
              <div className="mt-4 noPrint mx-3">
                <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
                <Row className="">
                  {prevAttachments &&
                    prevAttachments.map((attachment) => (
                      <Col
                        xs={1}
                        onClick={() => {
                          setPreviewFile(attachment.file_url)
                          setPreview(true)
                        }}
                        className="cursor-pointer preview-container"
                      >
                        <img
                          src={attachment.file_url}
                          className="img-preview"
                        />
                      </Col>
                    ))}
                  {!prevAttachments ||
                    (prevAttachments.length === 0 && (
                      <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                          <img
                            src={noDataImg}
                            alt="no data found"
                            className="img-preview"
                          />
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </>
          )}
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
    </div>
  )
}

SalesPaymentForm.defaultProps = {
  add: false,
  edit: false,
}

export default SalesPaymentForm
